// @flow

import formatPrice from './formatPrice';

import type { PriceFormattingOptions } from '@zapier/design-system-revenue/src/types';

/**
 * Formats a price in pennies to be in dollars with the currency symbol
 */
export default (
  price: number,
  formattingOptions: PriceFormattingOptions,
  symbol: string = '$'
): string =>
  price >= 0
    ? `${symbol}${formatPrice(price, formattingOptions)}`
    : `–${symbol}${formatPrice(Math.abs(price), formattingOptions)}`;
